import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class WizardService {
	private pageWizard = new Subject<string>();
	public page_wizard = this.pageWizard.asObservable();

	private displayWizard = new Subject<boolean>();
	public display_wizard = this.displayWizard.asObservable();

	setDisplayWizard(value: boolean) {
		this.displayWizard.next(value);
	}

	setPageWizard(value: string) {
		this.pageWizard.next(value);
	}
}
